import { useLocalSearchParams } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { billReviewSourceAtom } from '../../../../bills/state/BillsAtoms';
import SpinwheelBillsProcessing from '../../../../onboarding/components/billReview/SpinwheelBillsProcessing';

export default function SpinwheelBillsProcessingScreen() {
    const { source } = useLocalSearchParams<{ source?: string }>();
    const setBillReviewSource = useSetAtom(billReviewSourceAtom);

    useEffect(() => {
        if (source === 'before-money-map-session') {
            setBillReviewSource('home-review');
        } else if (source === 'home') {
            setBillReviewSource('home');
        }
    }, [source, setBillReviewSource]);

    return <SpinwheelBillsProcessing />;
}
